export default __webpack_public_path__ + "static/media/last-pdf-bg.efd1a064.png";